export enum UserRoles {
  ADMIN = 'admin',
  COLLABORATOR = 'collaborator',
  VIEWER = 'viewer',
  APPROVER = 'approver',
  ACCOUNTANT = 'accountant'
}
